import { getSpritesForSlot } from "../../data/sprites";
import type { SceneLayerSlot } from "../../shared/game";
import { PixelArtCanvas } from "../canvas/PixelArtCanvas";

type SpritePickerProps = {
  activeSlot: SceneLayerSlot;
  selectedSpriteId: string | null;
  onLoadSprite: (spriteId: string) => void;
  onClear: () => void;
};

export function SpritePicker({ activeSlot, selectedSpriteId, onLoadSprite, onClear }: SpritePickerProps) {
  const sprites = getSpritesForSlot(activeSlot);
  const activeSprite = sprites.find((sprite) => sprite.id === selectedSpriteId);

  return (
    <div>
      <div style={{ marginBottom: 10, fontSize: 11, color: "#9ea3b5" }}>
        Assign a sprite to the <strong style={{ color: "#fff" }}>{activeSlot}</strong> layer.
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 8 }}>
        <button type="button" onClick={onClear} style={{ minWidth: 0, borderRadius: 12, border: `1px solid ${selectedSpriteId ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.35)"}`, background: selectedSpriteId ? "transparent" : "rgba(255,255,255,0.05)", padding: 6 }}>
          <div style={{ width: "100%", aspectRatio: "1 / 1", borderRadius: 8, background: "repeating-conic-gradient(#12121f 0% 25%,#1a1a2e 0% 50%) 0 0/8px 8px", display: "grid", placeItems: "center", fontSize: 16 }}>✏️</div>
          <div style={{ marginTop: 5, fontSize: 10, color: "#858ba1", fontWeight: 600 }}>Blank</div>
        </button>
        {sprites.map((sprite) => (
          <button key={sprite.id} type="button" onClick={() => onLoadSprite(sprite.id)} style={{ minWidth: 0, borderRadius: 12, border: `1px solid ${selectedSpriteId === sprite.id ? sprite.typeColor : "rgba(255,255,255,0.08)"}`, background: selectedSpriteId === sprite.id ? `${sprite.typeColor}18` : "transparent", padding: 6 }}>
            <PixelArtCanvas grid={sprite.grid} size={42} className="rounded-sm" />
            <div style={{ marginTop: 5, fontSize: 10, color: selectedSpriteId === sprite.id ? sprite.typeColor : "#858ba1", fontWeight: 600 }}>{sprite.name}</div>
          </button>
        ))}
      </div>
      {activeSprite && (
        <div style={{ marginTop: 12, borderRadius: 12, border: `1px solid ${activeSprite.typeColor}55`, background: `${activeSprite.typeColor}14`, padding: "10px 12px", color: activeSprite.typeColor, fontSize: 13 }}>
          {activeSprite.typeLabel} starter loaded. Use it as a base and overwrite anything.
        </div>
      )}
    </div>
  );
}
